var v1="<div class=\"form-group\"> <label>{{ vm.settings.displayName }}</label> <div class=\"input-group\"> <button type=\"submit\" class=\"btn btn-default\" ng-click=\"vm.download()\">Download</button> </div> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/lbaFileDownloader/lbaFileDownloader.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaFileDownloader/lbaFileDownloader.html
// module id = 269
// module chunks = 0